import { render, staticRenderFns } from "./VistaVisualizacionClientes.vue?vue&type=template&id=3713c0f0"
import script from "./VistaVisualizacionClientes.vue?vue&type=script&lang=js"
export * from "./VistaVisualizacionClientes.vue?vue&type=script&lang=js"
import style0 from "./VistaVisualizacionClientes.vue?vue&type=style&index=0&id=3713c0f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports